import React, { useCallback } from 'react';
import { useMessage } from '@tmapy/intl';

import { InfoBadge } from '@tmapy/style-guide';

import { subjectPersonMessages } from './subjectMessages';
import { useNazev, useRegistry } from './subjectHooks';

import type { SubjektResponse } from '../../openapi/types';
import { useAppContext, useHistoryAction } from '../../hooks';
import { getCmdCtrlUrl } from '../../utils/getcmdctrlurl';
import { RouteId } from '../../routes';

export const SubjectListItem: React.FC<SubjektResponse> = (props) => {
  const { appType } = useAppContext();
  const formatMessage = useMessage();
  const routeToSubjectDetail = useHistoryAction('managerSubjectDetail', { id: props.id });

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      if (event.ctrlKey || event.metaKey) {
        window.open(
          getCmdCtrlUrl('managerSubjectDetail' as RouteId, { appType, id: props.id }),
          '_blank',
        );
        return; // Ponech nativní chování
      }
      const selectText = window.getSelection();
      if (!selectText || selectText.toString() === '') {
        routeToSubjectDetail();
      }
    },
    [routeToSubjectDetail],
  );

  const registryItem = useRegistry(props.registry);
  const nazevItem = useNazev({
    typ_osoby: props.typ_osoby,
    nazev: props.nazev,
    jmeno: props.jmeno,
    prijmeni: props.prijmeni,
  });

  return (
    <tr onClick={handleClick}>
      <td className='sg-u-type-bold'>{nazevItem}</td>
      <td>{props.typ_osoby ? formatMessage.lookup(subjectPersonMessages, props.typ_osoby) : ''}</td>
      <td>{props.ico}</td>
      <td>{props.id_subjektu}</td>
      <td>{props.adresa}</td>
      <td>
        {registryItem.map(
          (item: string | null) => item && <InfoBadge key={item}>{item}</InfoBadge>,
        )}
      </td>
      <td>{props.poznamka}</td>
    </tr>
  );
};
